import { ItemV2WithETag } from '@idmc-ms-fabric/integration';
import { ITask, JobStatus } from '@infa-service/mdp-orchestration-api';
import { Reducer } from 'react';

import { API_STATUS } from '../../../utils/common-types';
import { IDQAPageAction, IDQAPageState } from './IDQAPage.Types';

type RequiredIDQAPageState = Required<IDQAPageState>;

export type IDQAPageReducerAction =
	| {
			type: IDQAPageAction.SELECT_TABLE;
			payload: RequiredIDQAPageState['table'];
	  }
	| {
			type: IDQAPageAction.SELECT_COLUMN;
			payload: RequiredIDQAPageState['column'];
	  }
	| {
			type: IDQAPageAction.UPDATE_JOB;
			payload: RequiredIDQAPageState['runningJobDetails'] | undefined;
	  }
	| {
			type: IDQAPageAction.UPDATE_TASKS;
			payload: ITask[] | undefined;
	  }
	| {
			type: IDQAPageAction.INIT_ERROR;
			payload: string;
	  }
	| {
			type: IDQAPageAction.INIT_SUCCESS;
	  }
	| {
			type: IDQAPageAction.INIT_LOADING;
	  }
	| {
			type: IDQAPageAction.UPDATE_CS;
			payload: RequiredIDQAPageState['catalogSrc'];
	  }
	| {
			type: IDQAPageAction.UPDATE_JOB_STATUS;
			payload: JobStatus;
	  }
	| {
			type: IDQAPageAction.REMOVE_TABLE_DETAILS;
	  }
	| {
			type: IDQAPageAction.SET_ARTIFACT_DETAILS;
			payload: ItemV2WithETag;
	  };

const IDQAPageReducer: Reducer<IDQAPageState, IDQAPageReducerAction> = (state, action): IDQAPageState => {
	switch (action.type) {
		case IDQAPageAction.SELECT_TABLE: {
			return { ...state, table: action.payload };
		}
		case IDQAPageAction.SELECT_COLUMN: {
			return { ...state, column: action.payload };
		}
		case IDQAPageAction.UPDATE_JOB: {
			return { ...state, runningJobDetails: { filters: action.payload?.filters } };
		}
		case IDQAPageAction.UPDATE_TASKS: {
			return { ...state, runningJobDetails: { ...state.runningJobDetails, tasks: action.payload } };
		}
		case IDQAPageAction.INIT_ERROR: {
			return { ...state, status: API_STATUS.FAILURE, errorMessage: action.payload };
		}
		case IDQAPageAction.INIT_SUCCESS: {
			return { ...state, status: API_STATUS.SUCCESS };
		}
		case IDQAPageAction.INIT_LOADING: {
			return {
				status: API_STATUS.LOADING,
				runningJobDetails: { filters: [] },
			};
		}
		case IDQAPageAction.UPDATE_CS: {
			return { ...state, catalogSrc: action.payload };
		}
		case IDQAPageAction.UPDATE_JOB_STATUS: {
			return { ...state, runningJobDetails: { ...state.runningJobDetails, status: action.payload } };
		}
		case IDQAPageAction.REMOVE_TABLE_DETAILS: {
			return { ...state, table: undefined, column: undefined };
		}
		case IDQAPageAction.SET_ARTIFACT_DETAILS: {
			return { ...state, artifactDetails: action.payload };
		}
		default:
			return state;
	}
};

export default IDQAPageReducer;
